import { types } from '../types/types';

const emptyExtra = {
  text: '',
  from: '',
  to: '',
  catalogciius_id: '',
  catalogserie_id: '',
  state_catalog_id: '',
  current_user_id: '',
  flow_coverage_group_id: '',
  case_phase: ''
};

const initialState = {
  assignedOnly: true,
  showPending: false,
  showRejected: false,
  trayView: 'mine',
  extra: emptyExtra
};

export const flowListFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FLOW_LIST_FILTER_SET_ASSIGNED_ONLY:
      return {
        ...state,
        assignedOnly: action.payload !== false
      };
    case types.FLOW_LIST_FILTER_SET_SHOW_PENDING:
      return {
        ...state,
        showPending: action.payload === true
      };
    case types.FLOW_LIST_FILTER_SET_SHOW_REJECTED:
      return {
        ...state,
        showRejected: action.payload === true
      };
    case types.FLOW_LIST_FILTER_SET_EXTRA:
      return {
        ...state,
        extra: { ...emptyExtra, ...(action.payload || {}) }
      };
    case types.FLOW_LIST_FILTER_SET_TRAY_VIEW: {
      const trayView = String(action.payload || 'mine');
      return {
        ...state,
        trayView,
        assignedOnly: trayView === 'mine',
        extra: trayView === 'general'
          ? state.extra
          : { ...state.extra, current_user_id: '' }
      };
    }
    default:
      return state;
  }
};
